import { render, staticRenderFns } from "./five-floor.vue?vue&type=template&id=2f80a62c&scoped=true&"
import script from "./five-floor.vue?vue&type=script&lang=js&"
export * from "./five-floor.vue?vue&type=script&lang=js&"
import style0 from "./five-floor.vue?vue&type=style&index=0&id=2f80a62c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f80a62c",
  null
  
)

export default component.exports